import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaMotorcycle, FaList, FaHeart, FaChevronRight, FaCalculator } from 'react-icons/fa';

const PassengerShortcuts = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="bry-section-header">Accesos directos</div>
            <div className="bry-menu-list mb-3">
                <button className="bry-menu-item w-100 text-start border-0 bg-transparent" onClick={() => navigate('/solicitar-servicio')} style={{ cursor: 'pointer', color: 'var(--bry-text-primary)' }}>
                    <FaMotorcycle /> Solicitar Servicio 
                    <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} />
                </button>
                <button className="bry-menu-item w-100 text-start border-0 bg-transparent" onClick={() => navigate('/calculadora')} style={{ cursor: 'pointer', color: 'var(--bry-text-primary)' }}>
                    <FaCalculator style={{ color: 'var(--bry-accent)' }} /> Calculadora de Tarifas
                    <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} />
                </button>
                <button className="bry-menu-item w-100 text-start border-0 bg-transparent" onClick={() => navigate('/historial-servicios')} style={{ cursor: 'pointer', color: 'var(--bry-text-primary)' }}>
                    <FaList /> Historial
                    <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} />
                </button>
                <button className="bry-menu-item w-100 text-start border-0 bg-transparent" onClick={() => navigate('/favoritos')} style={{ cursor: 'pointer', color: 'var(--bry-text-primary)' }}>
                    <FaHeart color="#ec4899" /> Favoritos
                    <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} />
                </button>
            </div>
        </>
    );
};

export default PassengerShortcuts;
